module.exports = __webpack_public_path__ + "img/12_klio_11.9dcb39b4.jpg";